/* KIS pagina's: kleine onderdelen zonder bibliotheken.
   - <kis-tabs>: tabbladen (collage met tabs op Over ons)
   - <kis-recent-viewed>: recent bekeken producten uit localStorage "kis:recent"
   - <kis-countdown>: aftelbalk in de winkelwagenlade (zelfde logica als het live countdown-timer-2:
     telt af naar 21:00 of 09:00, of naar start-/einduur bij een vast schema)
   - winkelwagenlade: upsell-rail (vorige/volgende) en "Toevoegen"-knoppen via cart/add.js
   Custom elements starten zichzelf opnieuw na een her-render van de lade (innerHTML), inline scripts niet. */
(function () {
  'use strict';

  /* ---------- Tabbladen ---------- */
  if (!customElements.get('kis-tabs')) {
    customElements.define(
      'kis-tabs',
      class KisTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-kis-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-kis-panel]'));
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab.dataset.kisTab));
            tab.addEventListener('keydown', (e) => {
              const i = this.tabs.indexOf(tab);
              if (e.key === 'ArrowRight') this.focusTab(i + 1);
              if (e.key === 'ArrowLeft') this.focusTab(i - 1);
            });
          });
        }
        focusTab(i) {
          const n = this.tabs.length;
          const tab = this.tabs[((i % n) + n) % n];
          tab.focus();
          this.activate(tab.dataset.kisTab);
        }
        activate(index) {
          this.tabs.forEach((tab) => {
            const on = tab.dataset.kisTab === String(index);
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            const on = panel.dataset.kisPanel === String(index);
            panel.classList.toggle('is-active', on);
            panel.hidden = !on;
          });
        }
      }
    );
  }

  /* ---------- Recent bekeken ---------- */
  const RECENT_KEY = 'kis:recent';
  function readRecent() {
    try {
      const list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string' && h) : [];
    } catch (e) {
      return [];
    }
  }
  // Beschikbaar voor de productpagina: window.kisRecentViewed.add(handle)
  window.kisRecentViewed = window.kisRecentViewed || {
    key: RECENT_KEY,
    read: readRecent,
    add(handle) {
      if (!handle) return;
      const list = readRecent().filter((h) => h !== handle);
      list.unshift(handle);
      try {
        window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 20)));
      } catch (e) {
        /* geen opslag beschikbaar */
      }
    },
  };

  if (!customElements.get('kis-recent-viewed')) {
    customElements.define(
      'kis-recent-viewed',
      class KisRecentViewed extends HTMLElement {
        connectedCallback() {
          const limit = parseInt(this.dataset.limit || '8', 10);
          const exclude = this.dataset.exclude || '';
          const sectionId = this.dataset.section || 'kis-recent-viewed-card';
          const list = readRecent().filter((h) => h !== exclude).slice(0, limit);
          const target = this.querySelector('[data-kis-recent-list]');
          if (!list.length || !target) return;
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          Promise.all(
            list.map((handle) =>
              fetch(`${root}products/${encodeURIComponent(handle)}?section_id=${sectionId}`)
                .then((r) => (r.ok ? r.text() : ''))
                .then((html) => {
                  if (!html) return '';
                  const doc = new DOMParser().parseFromString(html, 'text/html');
                  const card = doc.querySelector('.kis-card');
                  return card ? card.outerHTML : '';
                })
                .catch(() => '')
            )
          ).then((cards) => {
            const html = cards.filter(Boolean).join('');
            if (!html) return;
            target.innerHTML = html;
            this.hidden = false;
          });
        }
      }
    );
  }

  /* ---------- Aftelbalk winkelwagenlade ---------- */
  if (!customElements.get('kis-countdown')) {
    customElements.define(
      'kis-countdown',
      class KisCountdown extends HTMLElement {
        connectedCallback() {
          this.scheduled = this.dataset.useScheduledTimer === 'true';
          this.startHour = parseInt(this.dataset.startHour || '9', 10);
          if (isNaN(this.startHour)) this.startHour = 9;
          this.endHour = (this.startHour + 12) % 24;
          const serverNow = this.dataset.serverNow ? new Date(this.dataset.serverNow.replace(' ', 'T')) : new Date();
          this.offset = isNaN(serverNow.getTime()) ? 0 : serverNow.getTime() - Date.now();
          this.endTime = this.nextEnd(new Date(Date.now() + this.offset));
          this.els = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]'),
          };
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        nextEnd(now) {
          const end = new Date(now);
          const h = now.getHours();
          const start = this.scheduled ? this.startHour : 9;
          const stop = this.scheduled ? this.endHour : 21;
          if (h >= start && h < stop) {
            end.setHours(stop, 0, 0, 0);
          } else {
            if (h >= stop) end.setDate(end.getDate() + 1);
            end.setHours(start, 0, 0, 0);
          }
          return end.getTime();
        }
        tick() {
          const now = Date.now() + this.offset;
          let d = this.endTime - now;
          if (d < 0) {
            this.endTime = this.nextEnd(new Date(now + 1000));
            d = this.endTime - now;
          }
          const days = Math.floor(d / 86400000);
          const hours = Math.floor((d % 86400000) / 3600000);
          const minutes = Math.floor((d % 3600000) / 60000);
          const seconds = Math.floor((d % 60000) / 1000);
          this.set(this.els.days, days);
          this.set(this.els.hours, hours);
          this.set(this.els.minutes, minutes);
          this.set(this.els.seconds, seconds);
        }
        set(el, value) {
          if (!el) return;
          const digits = String(value).padStart(2, '0').split('');
          const spans = el.querySelectorAll('[data-digit]');
          digits.forEach((digit, i) => {
            if (spans[i] && spans[i].textContent !== digit) spans[i].textContent = digit;
          });
        }
      }
    );
  }

  /* ---------- Winkelwagenlade: upsell-rail en toevoegen ---------- */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-kis-upsell-nav]');
    if (!btn) return;
    const rail = btn.closest('.kis-drawer-upsell').querySelector('[data-kis-upsell-rail]');
    if (!rail) return;
    const card = rail.querySelector('.kis-drawer-upsell__card');
    const step = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.7;
    rail.scrollBy({ left: btn.dataset.kisUpsellNav === 'next' ? step : -step, behavior: 'smooth' });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-kis-upsell-form]');
    if (!form) return;
    event.preventDefault();
    if (form.hasAttribute('data-processing')) return;
    form.setAttribute('data-processing', '');
    const drawer = document.querySelector('cart-drawer');
    const data = new FormData(form);
    const body = { items: [{ id: data.get('id'), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json.status) throw new Error(json.description || 'Fout');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(json);
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kis-upsell', productVariantId: data.get('id') });
        }
      })
      .catch((e) => console.error(e))
      .finally(() => form.removeAttribute('data-processing'));
  });
})();
